import getKey from 'lodash/get';

import React from 'react';
// import styled, { css } from 'styled-components';
import styled from 'styled-components';

import AntdRadio from 'antd/lib/radio';

import {
  asLocalStorageField,
} from 'hive-admin/src/components/FieldLocalStorage';

import Types from '../modules/types';

const I18nFieldRadioGroup = styled(AntdRadio.Group)`
  position: absolute;
  display: flex;
  right: 0px;
  top: 0px;
  text-transform: uppercase;
  transform-origin: top right;
  transform: scale(0.8) translate(8px, -8px);
  transition: transform 200ms 100ms ease-out, opacity 200ms 100ms linear;
  z-index: 3;
`;

const I18nFieldRadioGroupButtonLabelWrapper = styled.span`
  font-size: 11px;
`;

const I18nFieldWrapper = styled.div`
  position: relative;
  &:has(.ant-select-focused),
  &:has(.ant-input:focus) {
    > ${I18nFieldRadioGroup} {
      transform: scale(0.8) translate(8px, -30px);
      &:not(:hover) {
        /* opacity: 0.2; */
      }
    }
  }
`;

const I18nField = React.forwardRef((
  {
    // eslint-disable-next-line no-unused-vars
    $renderProps = {},
    $name,
    $languageId,
    $languages,
    $form,
    children,
    ...restProps
  },
  ref,
// eslint-disable-next-line arrow-body-style
) => {
  return (
    <I18nFieldWrapper>
      {
        React.cloneElement(
          children,
          { ...restProps, ref },
        )
      }
      <I18nFieldRadioGroup
        onChange={event => $form && $form.setFieldsValue({
          i18nLanguage: event.target.value,
        })}
        value={$languageId}
        size="small"
        // buttonStyle="solid"
      >
        {$languages.map(language => (
          <AntdRadio.Button
            key={language._id}
            value={language._id}
          >
            <I18nFieldRadioGroupButtonLabelWrapper>
              {Types.LANGUAGES_MAP?.[language._id]?.codeLabel || language._id}
            </I18nFieldRadioGroupButtonLabelWrapper>
          </AntdRadio.Button>
        ))}
      </I18nFieldRadioGroup>
      {/* <I18nFieldLanguagesWrapper>
        {$languages.map(languageId => (
          <I18nFieldLanguageItemWrapper
            key={languageId}
            data-active={languageId === $language}
            onClick={() => $form && $form.setFieldsValue({
              i18nLanguage: languageId,
            })}
          >
            <span>
              {languageId}
            </span>
          </I18nFieldLanguageItemWrapper>
        ))}
      </I18nFieldLanguagesWrapper> */}
    </I18nFieldWrapper>
  );
});

export const fieldI18nLanguage = asLocalStorageField(['FieldHidden', {
  name: 'i18nLanguage',
  key: 'i18nLanguage',
  virtual: [() => true],
  label: null,
  initialValue: 'en',
}], {
  getKey: (field, props) => {
    const id = props?.data?.store || props?.data?._id;
    if (!id) {
      return null;
    }
    return `${id}:${field.name}`;
  },
});

export const createGetI18nFields = ({
  // eslint-disable-next-line no-unused-vars
  languagesDataKey = 'storeData.languages',
// eslint-disable-next-line arrow-body-style
} = {}) => {
  return (values, props) => {
    const languageIds = props.viewer?.languages.map(({ _id }) => _id);
    const languagesMap = props.viewer?.languages.reduce(
      (agr, language) => {
        agr[language._id] = language;
        return agr;
      },
      {},
    );
    const topFormData = (
        props.datas?.length
      ? props.datas[props.datas.length - 1]
      : props.data
    );
    const storeLanguages = (
      props.activity === 'create'
      ? (
          props.viewer?.storeData?.languages
          || languageIds
        )
      : (
            topFormData?.global
          ? Object.keys(languagesMap)
          : getKey(
              topFormData,
              languagesDataKey,
              ['en'],
            )
        )
    ).sort(
      (a, b) => {
        if (a === 'en' && b === 'en') {
          return 0;
        }
        if (a === 'en') {
          return -Infinity;
        }
        if (b === 'en') {
          return Infinity;
        }
        a = Types.LANGUAGES_MAP[a].index;
        b = Types.LANGUAGES_MAP[b].index;
        return a - b;
      },
    );
    const languages = storeLanguages.map(
      languageId => languagesMap[languageId],
    );
    return props.fields.reduce(
      (agr, field) => {
        // console.log('doing');
        if (field.i18nTranslatable) {
          // console.log(languages);
          // const languageIds = languages.map(({ _id }) => _id);
          if (languages.length > 0) {
            languages.forEach((language) => {
              const isHidden = (hiddenProps) => {
                let i18nLanguageValue = null;
                const form = (
                    hiddenProps.forms
                  ? hiddenProps.forms[hiddenProps.forms.length - 1]
                  : hiddenProps.form
                );
                if (form && form.getFieldValue) {
                  i18nLanguageValue = form.getFieldValue('i18nLanguage');
                  // eslint-disable-next-line max-len
                  if (!languageIds.includes(i18nLanguageValue)) {
                    i18nLanguageValue = 'en';
                  }
                } else {
                  i18nLanguageValue = 'en';
                }
                return i18nLanguageValue !== language._id;
              };
              const newField = {
                ...field,
                // align: (
                //   field.align === 'right'
                //   ? field.align
                //   : language === 'ar'
                //   ? 'right'
                //   : field.align || 'left'
                // ),
                hidden: [...(field.hidden || []), isHidden],
                name: (
                    field.i18nGetFieldName
                  ? field.i18nGetFieldName(field, language._id)
                  : language._id === 'en'
                  ? field.name
                  : `i18n.${language._id}.${field.name}`
                ),
                rules: (field.rules || []).filter(rule => (
                    (
                      Array.isArray(rule)
                      && rule[0] === 'validation.isRequired'
                      && language._id !== 'en'
                    )
                  ? false
                  : true
                )),
                i18nLanguage: language._id,
              };
              if (language.direction === 'RTL') {
                newField.align = 'right';
              }
              const originalRender = field.render.bind(newField);
              // eslint-disable-next-line arrow-body-style
              newField.render = (renderProps) => {
                return (
                  <I18nField
                    $renderProps={renderProps}
                    $languageId={language._id}
                    $languages={languages}
                    $form={
                      renderProps.forms
                      ? renderProps.forms[renderProps.forms.length - 1]
                      : renderProps.form
                    }
                  >
                    {
                      React.cloneElement(
                        originalRender({
                          ...renderProps,
                          name: newField.name,
                          align: newField.align,
                          // align: newField.align,
                        }),
                        { name: newField.name },
                      )
                    }
                  </I18nField>
                );
              };
              agr.push(newField);
            });
          }
          // console.log(props.data?.storeData?.languages, field);
        } else {
          agr.push(field);
        }
        return agr;
      },
      [],
    );
  };
};

// eslint-disable-next-line arrow-body-style, import/prefer-default-export
export const getI18nFields = createGetI18nFields();
